<template>
  <div v-if="!isFramed" class="nav-menu-ct">
    <el-menu
      class="nav-menu"
      :collapse="isCollapsed"
      :router="false"
      :unique-opened="true"
      ref="mainMenu"
    >
      <!-- Level 1 navigation items -->
      <router-link
        :to="{
          name: dashboard.routeName,
          query: { project_id: projectId }
        }"
      >
        <nav-item
          v-if="dashboard.isAllowed()"
          :item="dashboard"
          :icon="true"
          css-class="dashboard-item"
        />
      </router-link>

      <el-submenu
        v-for="levelOneItem in filteredItems(navItems)"
        :key="levelOneItem.index"
        :index="levelOneItem.index"
        :class="[
          'level1',
          isCollapsed ? 'collapsedTopItemHover' : '',
          markAsActive === levelOneItem.index ? 'active-submenu' : ''
        ]"
        popper-class="nav-menu-popup-ct"
      >
        <template slot="title">
          <div class="level1-item">
            <icon :glyph="levelOneItem.icon" size="20" />
            <span>{{ $t(levelOneItem.sectionName) }}</span>
          </div>
        </template>

        <div v-if="isCollapsed" class="collapse-section-header">
          <icon :glyph="levelOneItem.icon" size="20" />
          <span>{{ $t(levelOneItem.sectionName) }}</span>
        </div>

        <!-- Level 2 navigation items -->
        <el-menu
          v-for="levelTwoItem in filteredItems(levelOneItem.subItems)"
          :key="levelTwoItem.index"
          :router="false"
          class="level2-submenu"
          ref="subMenu"
        >
          <!-- Level 3 navigation items -->
          <sub-menu
            v-if="levelTwoItem.subItems"
            :item="levelTwoItem"
            :index="levelTwoItem.index"
            css-class="level2"
            class="level1"
          />

          <template v-if="!levelTwoItem.subItems">
            <nav-item :item="levelTwoItem" css-class="level2" />
          </template>
        </el-menu>
      </el-submenu>

      <router-link
        v-if="
          customerIntelligence.isAllowed() &&
            !customerIntelligence.withSubmenu()
        "
        :to="{
          name: customerIntelligence.routeName,
          query: { project_id: projectId }
        }"
      >
        <nav-item
          :item="customerIntelligence"
          :icon="true"
          css-class="dashboard-item"
        />
      </router-link>

      <router-link
        v-if="mlStudio.isAllowed()"
        :to="{
          name: mlStudio.routeName,
          query: { project_id: projectId }
        }"
      >
        <nav-item
          :item="mlStudio"
          :icon="true"
          :is-new="!mlStudio.isEnabled()"
          css-class="dashboard-item"
        />
      </router-link>

      <el-submenu
        v-for="levelOneItem in filteredItems(endMenuItems)"
        :key="levelOneItem.index"
        :index="levelOneItem.index"
        :class="[
          'level1',
          isCollapsed ? 'collapsedTopItemHover' : '',
          markAsActive === levelOneItem.index ? 'active-submenu' : ''
        ]"
        popper-class="nav-menu-popup-ct"
      >
        <template slot="title">
          <div class="level1-item">
            <icon :glyph="levelOneItem.icon" size="20" />
            <span>{{ $t(levelOneItem.sectionName) }}</span>
          </div>
        </template>

        <div v-if="isCollapsed" class="collapse-section-header">
          <icon :glyph="levelOneItem.icon" size="20" />
          <span>{{ $t(levelOneItem.sectionName) }}</span>
        </div>

        <!-- Level 2 navigation items -->
        <el-menu
          v-for="levelTwoItem in filteredItems(levelOneItem.subItems)"
          :key="levelTwoItem.index"
          :router="false"
          class="level2-submenu"
          ref="subMenu"
        >
          <!-- Level 3 navigation items -->
          <sub-menu
            v-if="levelTwoItem.subItems"
            :item="levelTwoItem"
            :index="levelTwoItem.index"
            css-class="level2"
            class="level1"
          />

          <template v-if="!levelTwoItem.subItems">
            <nav-item :item="levelTwoItem" css-class="level2" />
          </template>
        </el-menu>
      </el-submenu>
    </el-menu>

    <!-- Collapse button -->
    <div class="collapse-ct" @click="handleCollapseClick">
      <icon
        glyph="navigation-collapse-chevron"
        :class="{ collapse: isCollapsed }"
        size="20"
      />
    </div>
  </div>
</template>

<script>
import dashboard from '@/common/components/navigation/navigation-section-items/dashboard.js'
import analyticsItems from '@/common/components/navigation/navigation-section-items/analytics.js'
import campaignItems from '@/common/components/navigation/navigation-section-items/campaign.js'
import contentItems from '@/common/components/navigation/navigation-section-items/content.js'
import dataItems from '@/common/components/navigation/navigation-section-items/data.js'
import settingsItems from '@/common/components/navigation/navigation-section-items/settings.js'
import customerIntelligence from '@/common/components/navigation/navigation-section-items/customer-intelligence.js'
import mlStudio from '@/common/components/navigation/navigation-section-items/ml-studio.js'
import gamification from '@/common/components/navigation/navigation-section-items/gamification.js'

import subMenu from '@/common/components/navigation/LeftNavigationSubMenu'
import navItem from '@/common/components/navigation/LeftNavigationItem'
import { EventBus } from '@/core/EventBus'

export default {
  name: 'LeftNavigationMenu',

  components: { subMenu, navItem },

  data() {
    return {
      isCollapsed: false,
      markAsActive: '',
      dashboard: dashboard,
      customerIntelligence: customerIntelligence,
      mlStudio: mlStudio,
      endMenuItems: [gamification, settingsItems]
    }
  },

  computed: {
    projectId() {
      return this.$store.getters.projectId
    },
    navItems() {
      return [
        analyticsItems,
        campaignItems,
        contentItems,
        dataItems,
        this.customerIntelligence.withSubmenu()
          ? this.customerIntelligence
          : null
      ].filter(item => item)
    },
    isFramed() {
      return window.top !== window.self
    }
  },

  methods: {
    filteredItems(items) {
      return items.filter(
        item => !item.hasOwnProperty('isAllowed') || item.isAllowed(item)
      )
    },

    handleCollapseClick() {
      window.localStorage.setItem(
        'navState',
        !this.isCollapsed ? 'collapsed' : 'expanded'
      )
      this.isCollapsed = !this.isCollapsed
      EventBus.$emit(
        'nav-state-change',
        this.isCollapsed ? 'collapsed' : 'expanded'
      )
    },

    /**
     * Set the active navigation item based on the route/subroute name and open the relevant sub menu
     */
    setActiveSubItem() {
      if (this.isFramed) {
        return
      }

      const routeName = this.$route.name
      const mainMenu = this.$refs.mainMenu
      const subMenus = this.$refs.subMenu

      // unset previous active selection
      this.markAsActive = ''

      // iterate through nav top level items
      this.navItems.forEach(l1 => {
        // iterate through nav level 2 items
        // this level has both level 2 clickable items and subroutes containing clickable items
        l1.subItems.forEach(l2 => {
          if (l2.routeName || l2.subRouteName) {
            // match the saved nav item route/subroute name with the route name from the Vue router
            if (
              (l2.subRouteName && l2.subRouteName.includes(routeName)) ||
              l2.routeName === routeName
            ) {
              // set the top level nav colour
              this.markAsActive = this.getMenuIndex(l2.index)

              // do not open main menu if nav is collapsed
              if (!this.isCollapsed) {
                mainMenu.open(this.getMenuIndex(l2.index))
              }

              // return if found match and disable linter check that complains about empty return
              // eslint-disable-next-line
              return
            }
          }

          // check for level 3 items and iterate through them
          if (l2.subItems) {
            l2.subItems.forEach(l3 => {
              // match the saved nav item route/subroute name with the route name from the Vue router
              if (
                (l3.subRouteName && l3.subRouteName.includes(routeName)) ||
                l3.routeName === routeName
              ) {
                // set the top level nav colour
                this.markAsActive = this.getMenuIndex(l3.index)

                // do not open main menu if nav is collapsed
                if (!this.isCollapsed) {
                  mainMenu.open(this.getMenuIndex(l3.index))
                }

                // open the relevant level 2 subtab
                subMenus.forEach(menu => {
                  if (Object.keys(menu.items).includes(l3.index)) {
                    menu.open(l3.index.match(/^\d+-\d+/)[0])
                  }
                })
                // return if found match and disable linter check that complains about empty return
                // eslint-disable-next-line
                return
              }
            })
          }
        })
      })
    },

    getMenuIndex(index, level = 0) {
      return index.split('-')[level]
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$refs.mainMenu && this.isCollapsed) {
          setTimeout(() => {
            this.$refs.mainMenu.openedMenus.forEach(openedMenuIndex => {
              this.$refs.mainMenu.close(openedMenuIndex)
            })
          }, 200)
        }

        this.$nextTick(() => {
          this.setActiveSubItem()
        })
      }
    },

    isCollapsed: {
      immediate: true,
      handler() {
        setTimeout(() => this.setActiveSubItem(), 400)
      }
    }
  },

  beforeMount() {
    this.isCollapsed = window.localStorage.getItem('navState') === 'collapsed'
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  width: 0;
}

.nav-menu-ct {
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 10;
}
@media screen and (max-height: 550px) {
  .nav-menu {
    overflow-y: scroll;
    overflow-x: hidden;
  }
}
.nav-menu {
  height: calc(100vh - 64px);
  user-select: none;
  background-color: #0c3650;
  overflow: auto;
}

.nav-menu ul.active {
  background-color: #176ca0;
}

.nav-menu li.active {
  background-color: #176ca0;
}

.nav-menu:not(.el-menu--collapse) {
  width: 304px;
}

.active-submenu {
  background-color: #115178;
}

.el-submenu.is-opened.level1.collapsedTopItemHover {
  background-color: #1d87c8;
}

.el-menu {
  border-right: 0;
}

>>> .el-menu {
  background-color: #0c3650;
}

.level1 >>> .el-submenu__title {
  height: 64px;
  line-height: 62px;
  color: #ffffff;
}

.level1 >>> .el-submenu__title i {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}

.level1-item {
  height: 64px;
  line-height: 62px;
}

.level1-item span {
  margin-left: 20px;
}

.level2-submenu {
  background-color: #115178;
  color: #ffffff;
  user-select: none;
}

.level2-submenu >>> .el-submenu__title {
  height: 48px;
  line-height: 46px;
}

.level2-submenu >>> .el-menu-item {
  color: #ffffff;
  height: 48px;
  line-height: 46px;
}

.level2-submenu >>> .el-submenu__icon-arrow {
  left: 37px;
  right: unset;
}

.collapse-section-header {
  display: flex;
  align-items: center;
  height: 64px;
  line-height: 62px;
  background-color: #115178;
  color: #ffffff;
  font-size: 14px;
  padding-left: 21px;
  user-select: none;
  position: sticky;
  top: 0;
  z-index: 10;
}

.collapse-section-header > span {
  margin-left: 20px;
}

.collapse-ct {
  width: 100%;
  height: 64px;
  background-color: #0c3650;
  border-top: 1px solid #115178;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
}

.collapse-ct div {
  color: #ffffff;
  margin-right: 22px;
}

.collapse {
  transform: rotateY(180deg);
}

>>> .el-menu-item:hover {
  background-color: #1d87c8;
}

>>> .el-menu-item:focus {
  background-color: #1d87c8;
}

>>> .el-submenu__title:hover {
  background-color: #1d87c8;
}

>>> .icon svg {
  fill: #ffffff;
}
</style>

<style lang="scss">
.nav-menu-popup-ct {
  background-color: #115178;
  top: 64px !important;
  bottom: 0 !important;
  width: 242px;
  overflow-x: hidden;
  overflow-y: scroll;

  .level1 .el-submenu__title {
    height: 48px !important;

    span {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .level2-submenu .el-submenu__icon-arrow {
    color: #ffffff;
    font-weight: bold;
    left: 30px;
  }

  .el-submenu__title {
    color: #ffffff;
    padding-left: 15px !important;
  }

  .el-menu-item {
    color: #ffffff;
    padding-left: 15px !important;
  }

  > ul {
    &.el-menu--popup {
      padding: 0;
      border-right: none;
      box-shadow: none;
    }
    &.el-menu--popup-right-start {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/LeftNavigation.vue